import React, { useState, useEffect } from 'react';
import { Button, Col, Modal, Form, Row, Spinner } from 'react-bootstrap';
import { useSelector, useDispatch } from 'react-redux';
import ReactChipInput from "react-chip-input";

import Multiselect from "../../components/Clima/Multiselect";
import { getDivision } from "../../redux/division/actions";
import { getOrgs } from "../../redux/organization/actions";
import { getAreasJerarquia } from "../../redux/areasfuncional/actions";

const SearchAvanceForm = ({isShowSearchModal, setIsShowSearchModal, searchFunc}) => {

  const [selectedOrgs, setSelectedOrgs] = useState([]);
  //const [isValidOrgs, setIsValidOrgs] = useState(true);
  //const [submitOrgs, setSubmitOrgs] = useState(false);
  const [selectedDivisions, setSelectedDivisions] = useState([]);
  //const [isValidDivisions, setIsValidDivisions] = useState(true);
  //const [submitDivisions, setSubmitDivisions] = useState(false);
  const [selectedUnitsOrgs, setSelectedUnitsOrgs] = useState([]);
  //const [isValidUnitsOrgs, setIsValidUnitsOrgs] = useState(true);
  //const [submitUnitsOrgs, setSubmitUnitsOrgs] = useState(false);
  const [selectedChips, setSelectedChips] = useState([]);

  
  const { orgs, loading: isLoadingOrgs } = useSelector((store) => store.orgs);
  const { division: divisions, loading: isLoadingDivisions } = useSelector((store) => store.division);
  const { areas: unitsOrgs, loading: isLoadingUnitsOrgs } = useSelector((store) => store.areas);

  const dispatch = useDispatch();

  useEffect(() => {
    // _getEmployeeMonitorEvents();
    dispatch(getDivision({}));
    dispatch(getOrgs(parseInt(2)));
    dispatch(getAreasJerarquia({}, 2, true));
  }, [dispatch]);

  const getOrgsOptions = () => {
    return orgs.map((org) => ({ label: org.nombre.toUpperCase(), value: org.id }));
  }

  const getDivisionsOptions = () => {
    return divisions.map((division) => ({ label: division.descripcion.toUpperCase(), value: division.id }));
  }

  const getUnitsOrgsOptions = () => {
    return unitsOrgs.map((unit) => ({ label: `${unit.codigo ? unit.codigo : ""} / ${
                                                unit.nombre ? unit.nombre.toUpperCase() : ""
                                              }`, codigo: unit.codigo, value: unit.id }));
  }

  const onAddChip = (chip) => {
    setSelectedChips((prev) => [...prev, chip]);
  }

  const onRemoveChip = (index) => {
    setSelectedChips((prev) => prev.filter((_, i) => i !== index));
  }

  
  const onSearch = (e) => {
    e.preventDefault();

    if (selectedOrgs.length === 0 && 
      selectedDivisions.length === 0 && 
      selectedUnitsOrgs.length === 0 && 
      selectedChips.length === 0) {
      return;
    }

    searchFunc({
      empresas: selectedOrgs ? selectedOrgs.map(item => item.value) : [],
      divisiones: selectedDivisions ? selectedDivisions.map(item => item.value) : [],
      unidades_org: selectedUnitsOrgs ? selectedUnitsOrgs.map(item => item.value) : [],
      empleados: selectedChips
    });

    setIsShowSearchModal(false);

  }

  return (
    <Modal show={isShowSearchModal} onHide={() => setIsShowSearchModal(false)}>
      <Modal.Header closeButton>
        <Modal.Title className="text-muted">Búsqueda avanzada</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form.Group as={Row}>
          <Form.Label column sm={3}>
            Empresa:
          </Form.Label>
          <Col sm={9}>
            <Row className="d-flex flex-wrap align-items-center">
              <Col sm={isLoadingOrgs ? "10" : "12"}>
                <Multiselect
                  options={getOrgsOptions()}
                  value={selectedOrgs}
                  onChange={setSelectedOrgs}
                  isValid={true}
                  isDisabled={isLoadingOrgs}
                  isSubmit={true}
                />
              </Col>
              {isLoadingOrgs && (
                <Col sm={1}>
                  <Spinner animation="border" size="sm" />
                </Col>
              )}
            </Row>
          </Col>
        </Form.Group>
        <Form.Group as={Row}>
          <Form.Label column sm={3}>
            División:
          </Form.Label>
          <Col sm={9}>
            <Row className="d-flex flex-wrap align-items-center">
              <Col sm={isLoadingDivisions ? "10" : "12"}>
                <Multiselect
                  options={getDivisionsOptions()}
                  value={selectedDivisions}
                  onChange={setSelectedDivisions}
                  isValid={true}
                  isDisabled={isLoadingDivisions}
                  isSubmit={true}
                />
              </Col>
              {isLoadingDivisions && (
                <Col sm={1}>
                  <Spinner animation="border" size="sm" />
                </Col>
              )}
            </Row>
          </Col>
        </Form.Group>
        <Form.Group as={Row} className="mb-md-0">
          <Form.Label column sm={3}>
            Unidad organizativa:
          </Form.Label>
          <Col sm={9}>
            <Row className="d-flex flex-wrap align-items-center">
              <Col sm={isLoadingUnitsOrgs ? "10" : "12"}>
                <Multiselect
                  className="rounded-pill"
                  options={getUnitsOrgsOptions()}
                  value={selectedUnitsOrgs}
                  onChange={setSelectedUnitsOrgs}
                  isValid={true}
                  isDisabled={isLoadingUnitsOrgs}
                  isSubmit={true}
                />
              </Col>
              {isLoadingUnitsOrgs && (
                <Col sm={1}>
                  <Spinner animation="border" size="sm" />
                </Col>
              )}
            </Row>
          </Col>
        </Form.Group>
        <Form.Group as={Row}>
          <Form.Label column sm={3}>
            Empleado:
          </Form.Label>
          <Col sm={9}>
            <Row>
              <Col sm={12}>
                <ReactChipInput
                  chips={selectedChips}
                  placeholder="Código o nombre del empleado"
                  onSubmit={onAddChip}
                  onRemove={onRemoveChip}
                />
              </Col>
            </Row>
            <div>
              <small className="text-muted mx-1">
                <b>Búsqueda por: Código o nombre de empleado</b>
              </small>
            </div>
            <div>
              <small className="text-muted mx-1">
                <b>
                  (Para agregar los elementos a la lista, presione la tecla
                  "Enter")
                </b>
              </small>
            </div>
          </Col>
        </Form.Group>
      </Modal.Body>
      <Modal.Footer>
        <Button
          className="rounded-pill"
          variant="secondary"
          onClick={() => setIsShowSearchModal(false)}>
          Cerrar
        </Button>
        <Button
          className="rounded-pill"
          variant="primary"
          type="button"
          onClick={(e) => onSearch(e)}>
          Buscar
        </Button>
      </Modal.Footer>
    </Modal>
  )
}

export default SearchAvanceForm